import type { ReactNode } from 'react';

export const symbol_cloud_alert: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M251-160q-88 0-149.5-61.5T40-371q0-78 50-137t127-71q20-97 94-158.5T482-799q112 0 189 81.5T748-522v24q72-2 122 46.5T920-329q0 69-50 119t-119 50H251Zm0-60h500q45 0 77-32t32-77q0-45-32-77t-77-32h-63v-84q0-91-61-154t-149-63q-88 0-149.5 63T267-522h-19q-62 0-105 43.5T100-371q0 63 44 107t107 44Zm229-260Zm21.5 141.5Q510-347 510-360t-8.5-21.5Q493-390 480-390t-21.5 8.5Q450-373 450-360t8.5 21.5Q467-330 480-330t21.5-8.5Zm0-130Q510-477 510-490v-120q0-13-8.5-21.5T480-640q-13 0-21.5 8.5T450-610v120q0 13 8.5 21.5T480-460q13 0 21.5-8.5Z"
		/>
	</svg>
);
